import React, { Component } from "react"
import ReactLoading from 'react-loading'
import Select from "../../../components/Select"
import helper from "../../../utils/helper"
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import { getClientesModulo, createOptionsClientes } from "../../../services/clientes"
import CsvDownloader from 'react-csv-downloader'
import pdfMake from 'pdfmake'
import { Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { components } from 'react-select'
import GenericInputDate from "../../../components/GenericInputDate"
import { lnsStatus } from "../../../utils/Enums/lnsStatus"

pdfMake.fonts = {
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    }
}

class RelatorioDispositivo extends Component {
    userInfo = auth.getUserInfo()
    isCliente = auth.isClient()

    state = {
        detalhes: {
            cliente: this.isCliente
                ? [{ label: this.userInfo.nome, value: this.userInfo.cliente }]
                : [],
            aplicacao: [],
            status: { label: "Todos", value: "TODOS" },
            periodo: null
        },
        carregando_dados: false,
        optionsClientes: [],
        optionsAplicacoesPorCliente: {},
        gerarRelatorio: true,
        relatorioGerado: false,
        csv: { data: [], columns: [] },
        dataRelatorio: {},
        optionsStatus: [
            { label: "Todos", value: "TODOS" },
            { label: "Ativo", value: "ONLINE" },
            { label: "Sem comunicação", value: "OFFLINE" },
            { label: "Inativo", value: "INATIVO" }
        ],
        modalVerPeriodo: false,
        periodo: [],
        info: {
            periodo: "Selecionar período traz os dados do período selecionado, se vazio será exibido os dados de hoje.",
            clientes: "Selecionar clientes traz o faturamento de cada cliente selecionado, se vazio gera dados de todos os clientes.",
            aplicacoes: "Selecionar aplicações traz os dispositivos da aplicação selecionada, se vazio gera dados de todos os dispositivos da aplicação.",
        }
    }

    componentDidMount = async () => {
        this.setState({ carregando_dados: true })
        await getClientesModulo('lns').then((clientes) => this.setState({ optionsClientes: createOptionsClientes(clientes) }))
        await this.getAplicacoes()
        this.setState({ carregando_dados: false })
    }

    getAplicacoes = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/application/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            let optionsAplicacoesPorCliente = {}

            optionsAplicacoesPorCliente["sem_cliente"] = []

            data.results.forEach((item) => {
                const clienteId = item.cliente
                const aplicacaoOption = { label: item.name, value: item.id, cliente: clienteId }

                if (clienteId) {
                    aplicacaoOption["cliente"] = { label: item.nome_cliente, value: clienteId }
                    optionsAplicacoesPorCliente[clienteId] = Array.isArray(optionsAplicacoesPorCliente[clienteId])
                        ? [...optionsAplicacoesPorCliente[clienteId], aplicacaoOption]
                        : [aplicacaoOption]
                } else {
                    optionsAplicacoesPorCliente["sem_cliente"] = [...optionsAplicacoesPorCliente["sem_cliente"], aplicacaoOption]
                }
            })

            this.setState({ optionsAplicacoesPorCliente })
        })
    }

    updateAplicacoesByClientes = (clientesSelecionados) => {
        const { optionsAplicacoesPorCliente } = this.state
        let aplicacoes = []

        if (!clientesSelecionados || clientesSelecionados.length === 0) {
            aplicacoes = optionsAplicacoesPorCliente["sem_cliente"]

            return aplicacoes
        }

        clientesSelecionados.forEach(cliente => {
            const key = cliente.value
            if (optionsAplicacoesPorCliente[key]) {
                aplicacoes = aplicacoes.concat(optionsAplicacoesPorCliente[key].map(app => ({
                    ...app,
                    cliente: cliente
                })))
            }
        })

        const seen = new Set()
        aplicacoes = aplicacoes.filter(app => {
            if (seen.has(app.value)) return false
            seen.add(app.value)
            return true
        })

        return aplicacoes
    }

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.state.detalhes)

        if (field === "cliente") {
            detalhes.cliente = value || []
            const novasAplicacoesDisponiveis = this.updateAplicacoesByClientes(detalhes.cliente)
            detalhes.aplicacao = (detalhes.aplicacao || []).filter(app =>
                novasAplicacoesDisponiveis.some(opt => opt.value === app.value)
            )
        } else if (field === "aplicacao") {
            detalhes.aplicacao = value || []
        } else {
            detalhes[field] = value
        }

        this.setState({ detalhes })
    }

    gerarRelatorio = () => {
        this.setState({ carregando_dados: true, relatorioGerado: false })

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/relatorio/dispositivo/'

        const data = {
            status: this.state.detalhes.status.value,
            aplicacoes: (this.state.detalhes.aplicacao || []).map((item) => item.value),
            periodo: {
                data_inicio: this.state.detalhes.periodo.startDate,
                data_fim: this.state.detalhes.periodo.endDate
            },
            clientes: (this.state.detalhes.cliente || []).map((item) => item.value)
        }

        axios({
            method: "POST",
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(({ data }) => {
            this.formatarCsv(data)

            if (!data.dispositivos || data.dispositivos.length === 0) {
                helper.dispatchEvent("showAviso", {
                    message: "Dados não encontrados!"
                })

                this.setState({ carregando_dados: false, relatorioGerado: false, dataRelatorio: {} })

                return
            }

            this.setState({ carregando_dados: false, relatorioGerado: true, dataRelatorio: data })
        })
            .catch((error) => {
                this.setState({ carregando_dados: false, relatorioGerado: false, dataRelatorio: {} })
            })
    }

    formatarCsv = (data) => {
        const csv = { data: [], columns: [] }

        csv.columns = [
            { id: 'c0', displayName: 'Nome do Dispositivo' },
            { id: 'c1', displayName: 'Dispositivo ID' },
            { id: 'c2', displayName: 'Aplicação ID' },
            { id: 'c3', displayName: 'Consumo' },
            { id: 'c4', displayName: 'Mensagens' },
            { id: 'c5', displayName: 'Status' },
            { id: 'c6', displayName: 'Primeira comunicação' },
            { id: 'c7', displayName: 'Última comunicação' }
        ]

        const limitarTexto = (texto) => {
            if (typeof texto !== 'string')
                texto = texto ? texto.toString() : ''
            let resultado = ''
            let i = 0
            while (i < texto.length) {
                resultado += texto.substring(i, i + 10)
                if (i + 10 < texto.length)
                    resultado += '\n'
                i += 10
            }
            return resultado
        }

        if (data && Array.isArray(data.dispositivos)) {
            data.dispositivos.forEach((item) => {
                const row = {
                    c0: limitarTexto(item.name),
                    c1: limitarTexto(item.dev_eui),
                    c2: limitarTexto(item.application_id),
                    c3: limitarTexto(`${item.total_megas} MB`),
                    c4: limitarTexto(item.total_mensagens),
                    c5: limitarTexto(lnsStatus[item?.state] ?? 'INATIVO'),
                    c6: limitarTexto(item?.first_seen ? item.first_seen : "---"),
                    c7: limitarTexto(item?.last_seen_at ? helper.convertDate(item.last_seen_at) : "---"),
                }

                csv.data.push(row)
                if (item.periodo && item.periodo.length > 0) {
                    csv.data.push({
                        c0: 'Data do registro',
                        c1: '',
                        c2: '',
                        c3: 'Período',
                        c4: '',
                        c5: '',
                        c6: '',
                        _headerStyle: true
                    })

                    item.periodo.forEach((periodo) => {
                        csv.data.push({
                            c0: limitarTexto(periodo.data_hora),
                            c1: limitarTexto(periodo.device_id),
                            c2: '',
                            c3: limitarTexto(`${periodo.total_megas} MB`),
                            c4: limitarTexto(periodo.total_mensagens),
                            c5: '',
                            c6: ''
                        })
                    })
                }

                csv.data.push({
                    c0: ' ',
                    c1: ' ',
                    c2: ' ',
                    c3: ' ',
                    c4: ' ',
                    c5: ' ',
                    c6: ' ',
                    _headerStyle: true
                })
            })

            csv.data.push(
                {
                    c0: 'Totais',
                    c1: limitarTexto(data.total_dispositivos),
                    c2: '',
                    c3: limitarTexto(`${data.total_megas} MB`),
                    c4: limitarTexto(data.total_mensagens),
                    c5: '',
                    c6: '',
                    c7: ''
                }
            )
        }

        this.setState({ csv })
    }

    exportarPDF = () => {
        const { csv } = this.state

        const columns = csv.columns.map(item => item.displayName)

        let table = []
        let widths = []

        const header_style = {
            fillColor: '#e0e0e0',
            color: '#444',
            bold: true,
            fontSize: 8
        }

        const headerRow = columns.map(col => ({
            text: col,
            ...header_style
        }))
        table.push(headerRow)

        columns.forEach(() => {
            widths.push("*")
        })

        csv.data.forEach((item) => {
            let row = []

            csv.columns.forEach((col, index) => {
                const key = `c${index}`
                let value = item[key] || ''

                if (item._headerStyle) {
                    row.push({ text: value, ...header_style })
                    return
                }

                if (item[key] === 'Totais') {
                    row.push({ text: value, ...header_style })
                    return
                }

                row.push({ text: value, fontSize: 8 })
            })

            table.push(row)
        })

        const pdfOptions = {
            pageOrientation: 'landscape',
            content: [
                {
                    table: {
                        widths: ['*', 80],
                        body: [
                            [
                                {
                                    text: ['\n', '\n', this.userInfo.email],
                                    border: [false, false, false, true]
                                },
                                { image: 'logo', style: 'logo', width: 80, border: [false, false, false, true] }
                            ]
                        ],
                    },
                },
                '\n\n\n',
                {
                    text: 'Relatório de Dispositivos',
                    style: 'header',
                    alignment: 'center'
                },
                '\n',
                {
                    table: {
                        widths: widths,
                        body: table,
                        headerRows: 1
                    },
                    layout: {
                        fillColor: function (rowIndex, node, columnIndex) {
                            return rowIndex === 0 ? '#e0e0e0' : null;
                        }
                    }
                }
            ],
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    margin: [0, 0, 0, 10]
                }
            },
            images: { 'logo': document.querySelector('div.hdv-logomarca img')?.src, },
        }

        const win = window.open('', '_blank')
        pdfMake.createPdf(pdfOptions).open({}, win)
    }



    modalVerPeriodo = (periodo) => {
        this.setState({ modalVerPeriodo: true, periodo: periodo })
    }

    showInfo = (info) => {
        helper.dispatchEvent("showAviso", {
            message: info
        })
    }

    render() {
        const { carregando_dados, detalhes, gerarRelatorio, relatorioGerado, optionsStatus, dataRelatorio, optionsClientes, modalVerPeriodo, periodo, info } = this.state

        const optionsAplicacoes = this.updateAplicacoesByClientes(detalhes.cliente)

        const { Option } = components
        const IconOption = (props) => {
            const colors = {
                "TODOS": '#207fcc',
                "ONLINE": '#2bb33f',
                "OFFLINE": '#e75c4f',
                "INATIVO": '#444444'
            }

            return (
                <Option {...props}>
                    <span className="d-flex align-items-center">
                        <i style={{ fontSize: '16px', color: colors[props.data.value] }} className="fa fa-square mr-1"></i>
                        <b style={{ color: props.isSelected ? 'white' : '#222', fontWeight: props.isSelected ? 'bold' : 'normal', opacity: 1 }}>{props.data.label}</b>
                    </span>
                </Option>
            )
        }

        return (
            <div className="hdv-render-div">
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <h4>Relatório de Dispositivo</h4>
                        <div className="gray-background">
                            <i className="las la-hdd la-2x"></i>
                        </div>
                    </span>
                    <ReactLoading className={(carregando_dados) ? "hdv-report-loading" : "hdv-noshow-item"} type="cylon" color="var(--background-menu)" width={50} />
                </div>

                <details open className='custom-summary'>
                    <summary>Filtros</summary>

                    <div className="hdv-form-default" style={{ padding: "0 20px 20px" }}>
                        <div className="row align-items-end">
                            <div className="col-md-6">
                                <label>
                                    Período
                                    &nbsp;
                                    <i className="las la-info-circle" style={{ cursor: "pointer" }} title={info.periodo} onClick={() => this.showInfo(info.periodo)}></i>
                                </label>
                                <GenericInputDate
                                    onChange={(objectDate) => this.handleChange("periodo", objectDate)}
                                    haveInitialValue
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="required">Status</label>
                                <Select
                                    components={{ Option: IconOption }}
                                    options={optionsStatus}
                                    value={detalhes.status}
                                    onChange={(e) => this.handleChange("status", e)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label>
                                    Clientes
                                    &nbsp;
                                    <i className="las la-info-circle" style={{ cursor: "pointer" }} title={info.clientes} onClick={() => this.showInfo(info.clientes)}></i>
                                </label>
                                <Select
                                    forceHeightAuto
                                    options={optionsClientes}
                                    value={detalhes.cliente}
                                    onChange={(e) => this.handleChange("cliente", e)}
                                    isMulti={true}
                                    disabled={carregando_dados || this.isCliente}
                                    placeholder="Todos"
                                />
                            </div>
                            <div className="col-md-6">
                                <label>
                                    Aplicações
                                    &nbsp;
                                    <i className="las la-info-circle" style={{ cursor: "pointer" }} title={info.aplicacoes} onClick={() => this.showInfo(info.aplicacoes)}></i>
                                </label>
                                <Select
                                    forceHeightAuto
                                    options={optionsAplicacoes}
                                    value={detalhes.aplicacao}
                                    onChange={(e) => this.handleChange("aplicacao", e)}
                                    isMulti={true}
                                    disabled={carregando_dados}
                                    placeholder="Todos"
                                />
                            </div>
                        </div>
                    </div>
                </details>
                <div className="hdv-btn-group">
                    <button disabled={!gerarRelatorio} onClick={this.gerarRelatorio} className="hdv-btn-forms hdv-btn-blue">Gerar Relatório</button>

                    <CsvDownloader
                        style={{ border: 'none' }}
                        columns={this.state.csv.columns}
                        datas={this.state.csv.data}
                        filename={`relatorio_lns_dispositivos.csv`}
                        separator=";"
                    >
                        <button disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-green">Exportar CSV</button>
                    </CsvDownloader>

                    <button onClick={this.exportarPDF} disabled={!relatorioGerado} className="hdv-btn-forms hdv-btn-red">Exportar PDF</button>
                </div>

                {relatorioGerado && dataRelatorio && Array.isArray(dataRelatorio.dispositivos) ?
                    <div style={{ overflow: "auto" }}>
                        <table className="table afira-table">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Dispositivo ID</th>
                                    <th>Aplicação ID</th>
                                    <th>Consumo</th>
                                    <th>Mensagens</th>
                                    <th>Status</th>
                                    <th>Primeira comunicação</th>
                                    <th>Última comunicação</th>
                                    <th>Período</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dataRelatorio.dispositivos.map((item, index) => {
                                        const status = {
                                            "1": 'success',
                                            "2": 'danger',
                                            "3": 'warning'
                                        }

                                        return (
                                            <tr key={index}>
                                                <td>{item.name ?? '---'}</td>
                                                <td>{item.dev_eui ?? '---'}</td>
                                                <td>{item.application_id ?? '---'}</td>
                                                <td>{item.total_megas ? `${item.total_megas} MB` : "---"} </td>
                                                <td>{item.total_mensagens ?? '---'}</td>
                                                <td>{<Badge color={status[item?.state] ?? 'secondary'}>{helper.convertLabelStatusLNS(lnsStatus[item?.state]) ?? 'Nunca comunicou'}</Badge>}</td>
                                                <td>{item.first_seen ? item.first_seen : "---"}</td>
                                                <td>{item?.last_seen_at ? helper.convertDate(item.last_seen_at) : "---"}</td>
                                                <td><button className="hdv-btn-forms hdv-btn-blue" onClick={() => this.modalVerPeriodo(item.periodo)}>Ver</button></td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td>Totais</td>
                                    <td colSpan={2}>{dataRelatorio.total_dispositivos}</td>
                                    <td>{dataRelatorio.total_megas} MB</td>
                                    <td colSpan={5}>{dataRelatorio.total_mensagens}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    : null}

                {modalVerPeriodo ?
                    <Modal isOpen={modalVerPeriodo} toggle={() => this.setState({ modalVerPeriodo: false })}>
                        <ModalHeader toggle={() => this.setState({ modalVerPeriodo: false })}>Detalhes do Período</ModalHeader>
                        <ModalBody>
                            <div className="hdv-form-default">
                                {periodo.length > 0 ?
                                    <table className="table afira-table">
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Dispositivo ID</th>
                                                <th>Conusmo</th>
                                                <th>Mensagens</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Array.isArray(periodo) && periodo.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.data_hora}</td>
                                                            <td>{item.device_id}</td>
                                                            <td>{item.total_megas} MB</td>
                                                            <td>{item.total_mensagens}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="row justify-content-center">
                                        <p>Sem dados no período</p>
                                    </div>
                                }
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <button className="hdv-btn-forms hdv-btn-blue" onClick={() => this.setState({ modalVerPeriodo: false })}>Fechar</button>
                        </ModalFooter>
                    </Modal>
                    : null}
            </div>
        )
    }
}

export default RelatorioDispositivo